import axios from "axios";
import './Revision.css'
import { useNavigate } from "react-router-dom";

const Revision = (props) => {

    const navigate = useNavigate();

    const ver = i => {
        const data = {
            placa_inspeccion: i
        }
        axios.post("https://cootransfusa.com/mantenimiento-cootransfusa/", props.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((response) => {
            props.handleDataReceived(response.data)
        })
        .catch((error) => {
            console.error(error);
        });
    }

    function logout() {
        localStorage.setItem("login", false);
        localStorage.setItem("loginStatus", "Sesión cerrada exitosamente");
        //navigate("/");
        window.location.href = "https://cootransfusa.com/mantenimiento/"
    }

    const regreso = () => {
        const data = {
            sesion: true,
            formato: false,
            ingreso: false
        }
        props.handleDataReceived(props.stringify(data))
    }

    return(
        <div>
            <button type="button" onClick={regreso} className="button_back ingreso_button ingreso_button_left"><i class="fa-solid fa-rotate-left" style={{ color: "#ffffff", marginRight: "10px" }}></i>Regresar</button>
            <button type="button" onClick={logout} className="button_logout ingreso_button ingreso_button_right">Cerrar Sesión<i class="fa-solid fa-right-from-bracket" style={{ color: "#ffffff", marginLeft: "10px" }}></i></button>
            
            <div className="revision_tabla">
                <table>
                    <th colSpan={6}>Revisiones Registradas</th>
                        <tbody>
                        <tr className="revision_tabla_columns">
                            <td><b>Item</b></td>
                            <td><b>Número</b></td>
                            <td><b>Placa</b></td>
                            <td><b>Fecha de Inspección</b></td>
                            <td><b>Autor Inspección</b></td>
                            <td><b>Ver</b></td>
                        </tr>

                            {props.formatoData.inspecciones.map(i => (
                                <tr>
                                    <td>{i.id_inspec}</td>
                                    <td>{i.interno_inspec}</td>
                                    <td>{i.placa_vehic_inspec}</td>
                                    <td>{i.fecha_inspec}</td>
                                    <td>{i.usuario_inspec}</td>
                                    <td><button type="button" onClick={() => ver(i.id_inspec)}><i class="fa-solid fa-eye" style={{color: "#000205",}}></i></button></td>
                                </tr>
                            
                            ))}
                    </tbody>
                </table>
            </div>

        </div>
    )
}

export default Revision